import useProtoMethod from "./useProtoMethod";
import {
  RecordClientEventRequest,
  RecordClientEventResponse,
} from "protogen/client_events_service_pb";

// Keep in sync with ClientEventName in src/python/datamodels/client_events.py.
export type ClientEventName =
  | "referral-banner-link-click"
  | "referral-link-copy"
  | "referral-message-copy";

export const useTrackClientEvent = () => {
  const { request } = useProtoMethod<
    RecordClientEventRequest,
    RecordClientEventResponse
  >("RecordClientEvent", RecordClientEventResponse);
  return (eventName: ClientEventName, meta: Record<string, string> = {}) => {
    request({ eventName, meta });
  };
};
